import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { createReducer } from "redux-act";

import { reduxActions } from "../actions/index";
import { red } from "@material-ui/core/colors";

const initial = {
  termsVersion: null,
  acceptNewTerms: false,
  temporaryAcc: null,
  lang: localStorage.language ? localStorage.language : "en",
  idTypes: null,
  similarProfile: false,
  loginError: false,
  otpEnabled: false,
  otpDisabled: false,
  wasFileUploaded: false,
  territories: [],
  onVerificationScreen: false,
  continueVerification: false,
  verificationResponse: false,
  otpSecret: null,
  apiKeys: null,
  passResetStarted: false,
  passResetComplete: false,
  toggleIPForm: false,
  ipConfirmation: null,
  emailVerificationError: null,
  jumioUploadFinished: {
    sent: false,
    finished: false,
    error: false,
  },
  level6UploadFinished: {
    sent: false,
    finished: false,
    error: false,
  },
  emailCodeResent: {
    codeSent: null,
    error: null,
  },
  countries: null,
  nationalities: null,
  occupations: null,
  phoneCodes: null,
  newApiKey: {
    exp: null,
    jti: null,
    token: null,
    scopes: null,
    updated: false,
  },
  notificationCenter: {
    message: null,
    type: "",
  },
  signUpResponse: {
    account: null,
    updated: false,
    errors: null,
    success: false,
  },
  account: {
    account: null,
    updated: false,
  },
  phoneResponse: {
    method: null,
    codeSent: false,
    error: null,
    code_verified: false,
  },
  profileResponse: {
    isProfileSubmitted: false,
  },
  institutional: {
    institution: null,
    updated: false,
  },
  institutionCreated: false,
  apiSummary: null,
};

const wasFileUploaded = createReducer(
  {
    [reduxActions.fileUploaded]: (state, payload) => {
      return payload;
    },
  },
  initial.wasFileUploaded
);

const lang = createReducer(
  {
    [reduxActions.getLang]: (state, payload) => {
      let lang = localStorage.language ? localStorage.language : "en";

      return lang;
    },
    [reduxActions.setNewLang]: (state, payload) => {
      localStorage.language = payload;

      return payload;
    },
  },
  initial.lang
);

const acceptNewTerms = createReducer(
  {
    [reduxActions.fillAcceptNewTerms]: (state, payload) => {
      return payload;
    },
    [reduxActions.rejectTerms]: (state, payload) => {
      return initial.acceptNewTerms;
    },
  },
  initial.acceptNewTerms
);

const termsVersion = createReducer(
  {
    [reduxActions.fillTermsVersion]: (state, payload) => {
      return payload.version;
    },
  },
  initial.termsVersion
);

const loginError = createReducer(
  {
    [reduxActions.fillLoginError]: (state, payload) => {
      return payload;
    },
  },
  initial.loginError
);

const temporaryAcc = createReducer(
  {
    [reduxActions.fillTemporaryAcc]: (state, payload) => {
      return payload;
    },
    [reduxActions.cleanTemporaryAcc]: (state, payload) => {
      return initial.temporaryAcc;
    },
  },
  initial.temporaryAcc
);

const similarProfile = createReducer(
  {
    [reduxActions.similarProfileToggle]: (state, payload) => {
      return payload;
    },
  },
  initial.similarProfile
);

const idTypes = createReducer(
  {
    [reduxActions.fillIDtypes]: (state, payload) => {
      return payload;
    },
  },
  initial.idTypes
);

const territories = createReducer(
  {
    [reduxActions.fillTerritories]: (state, payload) => {
      return payload;
    },
    [reduxActions.cleanTerritories]: (state, payload) => {
      return initial.territories;
    },
  },
  initial.territories
);

const onVerificationScreen = createReducer(
  {
    [reduxActions.showVerificationScreen]: (state, payload) => {
      return payload;
    },
  },
  initial.onVerificationScreen
);

const phoneCodes = createReducer(
  {
    [reduxActions.fillPhoneCodes]: (state, payload) => {
      return payload;
    },
  },
  initial.phoneCodes
);

const nationalities = createReducer(
  {
    [reduxActions.fillNationalities]: (state, payload) => {
      return payload;
    },
  },
  initial.nationalities
);

const countries = createReducer(
  {
    [reduxActions.fillCountries]: (state, payload) => {
      return payload;
    },
  },
  initial.countries
);

const occupations = createReducer(
  {
    [reduxActions.fillOccupations]: (state, payload) => {
      return payload;
    },
  },
  initial.occupations
);

const continueVerification = createReducer(
  {
    [reduxActions.continueVerification]: (state, payload) => {
      return payload;
    },
  },
  initial.continueVerification
);

const verificationResponse = createReducer(
  {
    [reduxActions.fillVerificationResponse]: (state, payload) => {
      return payload;
    },
  },
  initial.verificationResponse
);

const otpSecret = createReducer(
  {
    [reduxActions.fillOtpSecret]: (state, payload) => {
      return payload;
    },
    [reduxActions.cleanOtpSecret]: (state, payload) => {
      return null;
    },
  },
  initial.otpSecret
);

const jumioUploadFinished = createReducer(
  {
    [reduxActions.uploadJumioFinished]: (state, payload) => {
      return {
        sent: payload.sent,
        finished: payload.finished,
        error: payload.error,
      };
    },
  },
  initial.jumioUploadFinished
);

const level6UploadFinished = createReducer(
  {
    [reduxActions.uploadLevel6finished]: (state, payload) => {
      return {
        sent: payload.sent,
        finished: payload.finished,
        error: payload.error,
      };
    },
  },
  initial.level6UploadFinished
);

const otpEnabled = createReducer(
  {
    [reduxActions.fillOtpEnabled]: (state, payload) => {
      return payload;
    },
  },
  initial.otpEnabled
);

const otpDisabled = createReducer(
  {
    [reduxActions.fillOtpDisabled]: (state, payload) => {
      return payload;
    },
  },
  initial.otpDisabled
);

const apiKeys = createReducer(
  {
    [reduxActions.fillApiKeys]: (state, payload) => {
      return payload;
    },
  },
  initial.apiKeys
);

const emailCodeResent = createReducer(
  {
    [reduxActions.fillResendEmailCode]: (state, payload) => {
      return {
        codeSent: payload.codeSent,
        error: payload.error,
      };
    },
    [reduxActions.cleanEmailCodeResent]: (state, payload) => {
      return {
        ...initial.emailCodeResent,
      };
    },
  },
  initial.emailCodeResent
);

const passResetStarted = createReducer(
  {
    [reduxActions.passwordResetInitiated]: (state, payload) => {
      return payload;
    },
  },
  initial.passResetStarted
);

const passResetComplete = createReducer(
  {
    [reduxActions.passwordResetComplete]: (state, payload) => {
      return payload;
    },
  },
  initial.passResetComplete
);

const toggleIPForm = createReducer(
  {
    [reduxActions.showIPForm]: (state, payload) => {
      return payload;
    },
  },
  initial.toggleIPForm
);

const ipConfirmation = createReducer(
  {
    [reduxActions.fillIpConfirmation]: (state, payload) => {
      return payload;
    },
  },
  initial.ipConfirmation
);

const emailVerificationError = createReducer(
  {
    [reduxActions.emailVerificationError]: (state, payload) => {
      return payload;
    },
  },
  initial.emailVerificationError
);

const newApiKey = createReducer(
  {
    [reduxActions.fillNewApiKey]: (state, payload) => {
      return {
        exp: payload.exp,
        jti: payload.jti,
        token: payload.token,
        scopes: payload.scp,
      };
    },
    [reduxActions.cleanNewApiKey]: (state, payload) => {
      return {
        ...initial.newApiKey,
      };
    },
  },
  initial.newApiKey
);

const notificationCenter = createReducer(
  {
    [reduxActions.pushNotification]: (state, payload) => {
      return {
        ...state,
        message: payload.message,
        type: payload.type,
      };
    },
    [reduxActions.cleanNotifications]: (state, payload) => {
      return {
        ...initial.notificationCenter,
      };
    },
  },
  initial.notificationCenter
);

const signUpResponse = createReducer(
  {
    [reduxActions.handleSignUpRequest]: (state, payload) => {
      return {
        ...state,
        account: payload.account,
        success: payload.success,
        errors: payload.errors,
        updated: true,
      };
    },
  },
  initial.signUpResponse
);

const account = createReducer(
  {
    [reduxActions.fillAccount]: (state, payload) => {
      // If payload is null, then erase current invalid token

      if (payload === null) {
        localStorage.token = "";

        return {
          ...state,
          account: null,
          updated: true,
        };
      }

      // else fill Account
      localStorage.token =
        typeof payload.token === "undefined"
          ? localStorage.token
          : payload.token;

      return {
        ...state,
        account: {
          ...payload,
          token: "",
        },
        updated: true,
      };
    },
  },
  initial.account
);

const phoneResponse = createReducer(
  {
    [reduxActions.fillPhoneResponse]: (state, payload) => {
      return {
        ...state,
        error: payload.error,
        method: payload.method,
        codeSent: payload.codeSent,
        code_verified: payload.code_verified,
      };
    },
    [reduxActions.cleanPhoneResponse]: (state, payload) => {
      return {
        ...initial.phoneResponse,
      };
    },
  },
  initial.phoneResponse
);

const profileResponse = createReducer(
  {
    [reduxActions.fillProfileResponse]: (state, payload) => {
      return {
        ...state,
        isProfileSubmitted: payload.isProfileSubmitted,
      };
    },
    [reduxActions.cleanProfileResponse]: (state, payload) => {
      return {
        ...initial.cleanProfileResponse,
      };
    },
  },
  initial.profileResponse
);

const institutional = createReducer(
  {
    [reduxActions.fillInstitution]: (state, payload) => {
      if (payload === "notFound") {
        return {
          institution: payload,
          updated: true,
        };
      }
      return {
        institution: payload,
        updated: true,
      };
    },
  },
  initial.institutional
);

const apiSummary = createReducer(
  {
    [reduxActions.fillApiSummary]: (state, payload) => {
      return payload;
    },
  },
  initial.apiSummary
);

export default function createRootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    lang,
    account,
    idTypes,
    territories,
    otpSecret,
    signUpResponse,
    onVerificationScreen,
    phoneResponse,
    profileResponse,
    notificationCenter,
    continueVerification,
    apiKeys,
    passResetStarted,
    passResetComplete,
    verificationResponse,
    toggleIPForm,
    ipConfirmation,
    emailVerificationError,
    newApiKey,
    emailCodeResent,
    similarProfile,
    otpEnabled,
    otpDisabled,
    termsVersion,
    acceptNewTerms,
    temporaryAcc,
    wasFileUploaded,
    loginError,
    countries,
    nationalities,
    occupations,
    jumioUploadFinished,
    level6UploadFinished,
    phoneCodes,
    institutional,
    apiSummary,
  });
}
